import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var AddImageSvg = function AddImageSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.872 2H2v17.961h10.304v-1.466H3.459v-6.781h.336a8.65 8.65 0 0 1 7.428 4.226l1.25-.755a10.11 10.11 0 0 0-8.678-4.937H3.46V3.466h14.954v7.515h1.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.167 13.752v3.391h-3.374v1.466h3.374V22h1.46v-3.39H22v-1.467h-3.374v-3.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 5.635a3 3 0 0 1 4.255 0 3.03 3.03 0 0 1 0 4.277 3 3 0 0 1-4.255 0 3.03 3.03 0 0 1 0-4.277m2.128.58c-.412 0-.806.165-1.097.457a1.56 1.56 0 0 0 0 2.203 1.546 1.546 0 0 0 2.193 0 1.56 1.56 0 0 0 0-2.203 1.55 1.55 0 0 0-1.096-.457",
    clipRule: "evenodd"
  }));
};
export var AddImage = function AddImage(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: AddImageSvg
  }));
};